export default function StepperActiveIco({ size }) {
  return (
    <svg
      width={size || "32"}
      height={size || "32"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4331_13316)">
        <circle cx="16" cy="16" r="16" fill="white" />
        <path
          d="M16 0C12.8355 0 9.74207 0.938383 7.11088 2.69649C4.4797 4.45459 2.42894 6.95344 1.21793 9.87706C0.00693254 12.8007 -0.309921 16.0177 0.307443 19.1214C0.924806 22.2251 2.44866 25.0761 4.6863 27.3137C6.92394 29.5513 9.77487 31.0752 12.8786 31.6926C15.9823 32.3099 19.1993 31.9931 22.1229 30.7821C25.0466 29.5711 27.5454 27.5203 29.3035 24.8891C31.0616 22.2579 32 19.1645 32 16C32 13.8988 31.5861 11.8183 30.7821 9.87706C29.978 7.93585 28.7994 6.17203 27.3137 4.68629C25.828 3.20055 24.0641 2.022 22.1229 1.21793C20.1817 0.413852 18.1012 0 16 0ZM25.0816 13.1792L15.4816 21.9792C15.1777 22.2579 14.7778 22.4085 14.3656 22.3995C13.9533 22.3906 13.5604 22.2228 13.2688 21.9312L8.46881 17.1312C8.31599 16.9836 8.1941 16.807 8.11024 16.6118C8.02639 16.4166 7.98225 16.2067 7.9804 15.9942C7.97856 15.7818 8.01904 15.5711 8.09949 15.3745C8.17994 15.1778 8.29874 14.9992 8.44897 14.849C8.5992 14.6987 8.77784 14.5799 8.97448 14.4995C9.17111 14.419 9.3818 14.3785 9.59425 14.3804C9.80669 14.3822 10.0166 14.4264 10.2119 14.5102C10.4071 14.5941 10.5836 14.716 10.7312 14.8688L14.448 18.5856L22.9184 10.8208C23.2311 10.5339 23.645 10.3831 24.069 10.4014C24.493 10.4197 24.8923 10.6057 25.1792 10.9184C25.4661 11.2311 25.6169 11.645 25.5986 12.069C25.5803 12.493 25.3943 12.8923 25.0816 13.1792Z"
          fill="#17B26A"
        />
      </g>
      <defs>
        <clipPath id="clip0_4331_13316">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
